export default {
    data() {
        return {
            collapsed: false,
            defaultActive: '/console',
            menu: [{
                name: this.$global.HOME_TITLE,
                code: "console",
                icon: "iconfont ic-sys-computer",
                url: "/console",
                subs: []
            }, {
                name: "系统管理",
                code: "sys-manage",
                icon: "iconfont ic-sys-setting",
                url: "",
                subs: [{
                    name: "组织架构",
                    code: "org",
                    icon: "iconfont ic-sys-org",
                    url: "/org"
                }, {
                    name: "人员管理",
                    code: "user",
                    icon: "iconfont ic-sys-user",
                    url: "/user"
                }]
            }, {
                name: "承包商管理",
                code: "contractor-manage",
                icon: "iconfont ic-sys-contractor",
                url: "",
                subs: [{
                    name: "承包商类型",
                    code: "contractor-type",
                    icon: "iconfont ic-sys-contractor-type",
                    url: "/contractor_type"
                }, {
                    name: "承包商管理",
                    code: "contractor",
                    icon: "iconfont ic-sys-contractor-manage",
                    url: "/contractor"
                }, {
                    name: "岗位管理",
                    code: "contractor-post",
                    icon: "iconfont ic-sys-contractor-post",
                    url: "/contractor_post"
                }, {
                    name: "员工管理",
                    code: "contractor-employee",
                    icon: "iconfont ic-sys-contractor-member",
                    url: "/contractor_employee"
                }]
            }, {
                name: "培训管理",
                code: "train",
                icon: "iconfont ic-sys-train",
                url: "",
                subs: [{
                    name: "培训策略",
                    code: "train-strategy",
                    icon: "iconfont ic-sys-train-strategy",
                    url: "/train_strategy"
                }, {
                    name: "资料库",
                    code: "file",
                    icon: "iconfont ic-sys-data",
                    url: "/file"
                }]
            }, {
                name: "考试管理",
                code: "exam",
                icon: "iconfont ic-sys-exam",
                url: "",
                subs: [{
                    name: "考试策略",
                    code: "exam-strategy",
                    icon: "iconfont ic-sys-exam-strategy",
                    url: "/exam_strategy"
                }, {
                    name: "考试记录",
                    code: "exam-record",
                    icon: "iconfont ic-sys-exam-record",
                    url: "/exam_record"
                }, {
                    name: "考题库",
                    code: "exam-subject",
                    icon: "iconfont ic-sys-exam-subject",
                    url: "/exam_subject"
                }]
            }, {
                name: "证书中心",
                code: "certificate",
                icon: "iconfont ic-sys-certificate",
                url: "",
                subs: [{
                    name: "证书管理",
                    code: "certificate-manage",
                    icon: "iconfont ic-sys-certificate-manage",
                    url: "/certificate"
                }, {
                    name: "颁发记录",
                    code: "certificate-issue",
                    icon: "iconfont ic-sys-certificate-issue-record",
                    url: "/certificate_issue"
                }]
            }, {
                name: "个人中心",
                code: "mine",
                icon: "iconfont ic-sys-mine",
                url: "",
                subs: [{
                    name: "个人信息",
                    code: "my-info",
                    icon: "iconfont ic-sys-my-info",
                    url: "/my_info"
                }, {
                    name: "密码修改",
                    code: "update-password",
                    icon: "iconfont ic-sys-update-password",
                    url: "/update_password"
                }]
            }]
        }
    },
    mounted: function () {
        // 收缩、展开菜单事件接收
        this.$event.$on('changeCollapse', (collapsed) => {
            this.collapsed = collapsed;
        });
        var that = this;
        // 针对刷新后，菜单默认选中当前路由path
        this.defaultActive = this.$route.path;
        // 路由监听，用于设置菜单选中状态
        this.$router.afterEach(route => {
            that.defaultActive = route.path;
        });
    },
    methods: {

    }
}